import { createRootRouteWithContext, Outlet, useNavigate, useRouterState } from '@tanstack/react-router'
import { useEffect } from 'react'
import Spinner from '@tandem/ui/Spinner'
import Layout from '@/Layout'
import { useAuth } from '@/contexts/AuthContext'

export interface RouterContext {
  auth: {
    isAuthenticated: boolean
    isLoading: boolean
  }
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
})

function RootComponent() {
  let { isAuthenticated, isLoading, company } = useAuth()
  let navigate = useNavigate()
  let pathname = useRouterState({ select: (s) => s.location.pathname })

  let isPublicRoute = pathname === '/login'
  let isOnboarding = pathname === '/onboarding'

  useEffect(() => {
    if (!isPublicRoute && !isAuthenticated && !isLoading) {
      navigate({ to: '/login', search: { token: undefined } })
    }
  }, [isAuthenticated, isLoading, isPublicRoute, navigate])

  useEffect(() => {
    if (isAuthenticated && !isLoading && !company && !isPublicRoute && !isOnboarding) {
      navigate({ to: '/onboarding' })
    }
  }, [isAuthenticated, isLoading, company, isPublicRoute, isOnboarding, navigate])

  if (!isPublicRoute && !isAuthenticated) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <Spinner />
      </div>
    )
  }

  if (isPublicRoute || isOnboarding) {
    return <Outlet />
  }

  return (
    <Layout>
      <Outlet />
    </Layout>
  )
}
